import React, { forwardRef } from 'react';
import Button from '@/components/Button';

/**
 * bootstrap modal component
 * @param id
 * @param label
 * @param title
 * @param children can be an array of 2 elements or a single element
 * @returns {JSX.Element}
 * @constructor
 */
const Modal = forwardRef(
  ({ id, label, title, children, backdrop = 'static', openState = [false, () => {}] }, ref) => {
    const [open, setOpen] = openState;
    return (
      <div
        ref={ref}
        id={id || 'exampleModal'}
        className="modal fade"
        tabIndex="-1"
        data-bs-backdrop={backdrop}
        aria-labelledby={label || 'exampleModalLabel'}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">{title}</h3>
              <Button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setOpen(false);
                }}
              ></Button>
            </div>
            <div className="modal-body">{children[0] || children}</div>
            {children[1] && <div className="modal-footer">{children[1]}</div>}
          </div>
        </div>
      </div>
    );
  }
);

Modal.displayName = 'Modal';

export default Modal;
